import { PlaceholdersId, TFComponent } from '@types';
import { AuthenticatorFooterPlaceholder } from './authenticatorFooter';

export const authenticatorFooter: TFComponent = {
	component: AuthenticatorFooterPlaceholder,
	id: PlaceholdersId.authenticatorFooter,
	name: 'authenticatorFooter',
};
